import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-equip',
  templateUrl: './about-equip.component.html',
  styleUrls: ['./about-equip.component.scss']
})
export class AboutEquipComponent implements OnInit {

  public relPath:string = "./../../../../assets/Contents/imgs/Equipments_and_Devices/";
  selectedImage;

  constructor(private router:Router) { }

  ngOnInit() {
  }


  navigateTo(url) {
    this.router.navigateByUrl(url);
  }

  setSelectedImage(image){
      this.selectedImage = image;
      console.log(image)
   }

}



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-equip/about-equip.component.ts